export type EnvironmentKind = 'dev' | 'qa' | 'staging' | 'prod' | 'custom';

const LABEL: Record<EnvironmentKind, string> = { dev: 'DEV', qa: 'QA', staging: 'STAGING', prod: 'PROD', custom: 'CUSTOM' };
const NAME: Record<EnvironmentKind, string> = { dev: 'Development', qa: 'QA', staging: 'Staging', prod: 'Production', custom: 'Custom' };

/** Production is marked by colour, text and an icon together (never colour alone, baseline §6). */
export function EnvironmentBadge({ kind }: { kind: EnvironmentKind }) {
  const prod = kind === 'prod';
  return (
    <span data-testid="environment-badge" className={`bb-badge bb-tone--${prod ? 'prod' : kind === 'dev' ? 'dev' : 'neutral'}`} aria-label={`${NAME[kind]} environment`}>
      {prod && (
        <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M8 1 15 14H1L8 1Zm0 4v4.5m0 2v.01" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      )}
      {LABEL[kind]}
    </span>
  );
}
